<div #targetDiv class="row position-relative h-100">
  <ng-container *ngIf="isMobile; else notMobile">
    <ng-container *ngTemplateOutlet="splitter1"> </ng-container>

    <ng-container *ngTemplateOutlet="splitter2"> </ng-container>
  </ng-container>

  <ng-template #notMobile>
    <p-splitter
      [style]="{ height: '100%', border: 'none', width: '100%' }"
      [panelSizes]="dynamicPanelSizes"
      styleClass="mb-5"
      (onResizeEnd)="onSplitterResize($event)"
      panelStyleClass="overflow-x-auto"
      [minSizes]="[30, 0]">
      <ng-template pTemplate>
        <ng-container *ngTemplateOutlet="splitter1"></ng-container>
      </ng-template>
      <ng-template pTemplate>
        <ng-container *ngTemplateOutlet="splitter2"></ng-container>
      </ng-template>
    </p-splitter>
  </ng-template>
</div>

<ng-template #splitter1>
  <div class="col-lg-12" [class.pr-0]="!isMobile">
    <div class="property-details p-0 border-0 edit-main-padding">
      <div class="tabs-wrap">
        <div>
          <form class="tab-content form UserForm_tabs" [formGroup]="UserForm" #contactFormElement>
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade show active">
                <div class="dfx">
                  <div class="profile-section">
                    <div class="profile-thumb position-relative">
                      <div class="user-thumbnail-placeholder" [ngStyle]="imageError ? { border: '1px solid white' } : ''">
                        <span
                          class="ng-star-inserted text-uppercase"
                          *ngIf="!UserForm?.get('photo')?.value && (UserForm.get('first_name').value || UserForm.get('last_name').value)">
                          {{
                            (UserForm.get('first_name')?.value ? UserForm.get('first_name')?.value.charAt(0) : '') +
                              (UserForm.get('last_name')?.value ? UserForm.get('last_name')?.value.charAt(0) : '')
                          }}
                        </span>
                        <span
                          class="ng-star-inserted"
                          *ngIf="!UserForm?.get('photo')?.value && !UserForm.get('first_name').value && !UserForm.get('last_name').value">
                          D1
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="d-block w-xs-100">
                    <div class="dfl">
                      <div class="cs-width {{ isMobile ? '' : 'ml-2' }}">
                        <label for="type" class="mb-1">Contact Type</label>
                        <div class="form-group mb-0">
                          <ng-select
                            bindLabel="tag_name"
                            bindValue="value"
                            [items]="addType"
                            [multiple]="false"
                            [searchable]="false"
                            placeholder="Select Type"
                            formControlName="type"
                            class="primary-taged"
                            [readonly]="isPrivate"
                            (change)="contactTypeChanged()">
                            <ng-template ng-option-tmp let-item="item">
                              <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                      <div class="cs-width {{ isMobile ? '' : 'ml-2' }}" *ngIf="UserForm.controls['type'].value === 'Company'">
                        <label for="type" class="mb-1">Type</label>
                        <div class="form-group mb-0">
                          <ng-select
                            bindLabel="tag_name"
                            bindValue="tag_name"
                            [items]="companyType"
                            [multiple]="false"
                            [searchable]="true"
                            placeholder="Company Type"
                            formControlName="company_type"
                            class="primary-taged"
                            [readonly]="isPrivate">
                            <ng-template ng-option-tmp let-item="item">
                              <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                      <div class="cs-width {{ isMobile ? '' : 'ml-2' }}" *ngIf="UserForm.controls['type'].value === 'Contact'">
                        <label for="type" class="mb-1">Type</label>
                        <div class="form-group mb-0">
                          <ng-select
                            bindLabel="tag_name"
                            bindValue="tag_name"
                            [items]="contactType"
                            [multiple]="false"
                            [searchable]="true"
                            placeholder="Contact Type"
                            formControlName="contact_type"
                            class="primary-taged"
                            [readonly]="isPrivate">
                            <ng-template ng-option-tmp let-item="item">
                              <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <div class="flexCenterEnd my-2">
                      <ng-container
                        *ngIf="this.lmService?.visibilitySetting?.is_visibility_private || this.lmService?.visibilitySetting?.is_visibility_edit">
                        <button
                          *ngIf="lmService.isEdit_show_div === 'edit_contact' && api.getUserId() === selectedContact?.user_id"
                          [class.disabled]="loading || isPrivate"
                          pButton
                          pRipple
                          type="button"
                          pTooltip="Private Contact"
                          (click)="makePrivateContact(); own_cont.hide($event); shr_cont.hide($event)"
                          [icon]="selectedContact?.isPrivate == true ? 'pi pi-lock' : 'pi pi-lock-open'"
                          class="lock_icon"
                          [class.text-primarys]="selectedContact.isPrivate == true"></button>
                        <button
                          *ngIf="
                            lmService.isEdit_show_div === 'edit_contact' && selectedContact?.isPrivate && api.getUserId() !== selectedContact?.user_id
                          "
                          [class.disabled]="loading || isPrivate"
                          pButton
                          pRipple
                          type="button"
                          pTooltip="Private by {{ selectedContact?.creator }}"
                          [icon]="selectedContact?.isPrivate == true ? 'pi pi-lock' : 'pi pi-lock-open'"
                          class="lock_icon"
                          [class.text-primarys]="selectedContact.isPrivate == true"></button>
                        <button
                          *ngIf="
                            (lmService.isEdit_show_div === 'edit_contact' ||
                              userPermission.includes('contact_share.manage') ||
                              userRole == 'operations manager' ||
                              userRole == 'master admin') &&
                            !disabled_tab
                          "
                          [class.disabled]="loading || isPrivate"
                          pButton
                          pRipple
                          type="button"
                          pTooltip="Share Contact"
                          tooltipPosition="bottom"
                          icon="pi pi-share-alt"
                          (click)="shr_cont.show($event); own_cont.hide($event)"
                          class="lock_icon"></button>
                        <p-overlayPanel #shr_cont [dismissable]="true" [showCloseIcon]="true" appendTo="body" styleClass="my-custom-class">
                          <ng-template pTemplate>
                            <div class="overLayPanelBtn">
                              <label class="mb-2">Share Contact</label>
                              <div class="mb-2">
                                <re-multiSelect
                                  [options]="shareStaffUser"
                                  [(selectedOptions)]="users_to_share_with"
                                  optionLabel="full_name"
                                  optionValue="_id"
                                  placeholder="Select Users"></re-multiSelect>
                              </div>
                              <div class="mb-2">
                                <re-multiSelect
                                  [options]="teams"
                                  [(selectedOptions)]="teams_to_share_with"
                                  optionLabel="name"
                                  optionValue="_id"
                                  placeholder="Select Teams"></re-multiSelect>
                              </div>
                              <div class="mb-2">
                                <re-multiSelect
                                  [options]="offices"
                                  [(selectedOptions)]="office_to_share_with"
                                  optionLabel="name"
                                  optionValue="_id"
                                  placeholder="Select Office">
                                </re-multiSelect>
                              </div>
                              <div class="text-right mt-3">
                                <button type="button" class="preview-btn" (click)="ShareContact(); shr_cont.hide($event)">Share</button>
                              </div>
                            </div>
                          </ng-template>
                        </p-overlayPanel>
                        <div class="d-flex align-items-center" *ngIf="lmService.isEdit_show_div === 'edit_contact'">
                          <button
                            [class.disabled]="loading"
                            pButton
                            pRipple
                            type="button"
                            pTooltip="Owner: {{ selectedContact?.creator?.full_name }}"
                            icon="pi pi-user"
                            tooltipPosition="bottom"
                            class="lock_icon"
                            (click)="own_cont.show($event); shr_cont.hide($event)"></button>
                        </div>
                        <p-overlayPanel #own_cont [dismissable]="true" [showCloseIcon]="true" class="ownership-contact" appendTo="body">
                          <ng-template pTemplate>
                            <div class="w-300">
                              <label class="mb-1">Ownership</label>
                              <p class="f-14">Contact created by {{ selectedContact?.creator?.full_name }}</p>
                              <div *ngIf="isPrivate">
                                <div class="py-2 mt-2">
                                  <button
                                    type="button"
                                    class="btn btn-primary btn-sm btn-block"
                                    (click)="requestEditingContact(); own_cont.hide($event)">
                                    Request Editing
                                  </button>
                                </div>
                              </div>
                              <div
                                *ngIf="
                                  api.getUserId() === selectedContact?.user_id &&
                                  selectedContact?.edit_requestors_name &&
                                  selectedContact?.edit_requestors?.length > 0
                                ">
                                <div class="form-group mt-3">
                                  <label class="mb-1">Editing Requests</label>
                                  <div class="d-block">
                                    <span class="f-14 text-primarys font-italic">{{ selectedContact?.edit_requestors_name }}</span>
                                  </div>
                                </div>
                              </div>
                              <div
                                *ngIf="
                                  api.getUserId() === selectedContact?.user_id ||
                                  selectedContact?.owners?.includes(api.getUserId()) ||
                                  userRole == 'operations manager' ||
                                  userRole == 'master admin'
                                ">
                                <div class="form-group mt-3">
                                  <label class="mb-1">Select Editors</label>
                                  <re-multiSelect
                                    [options]="staffUsers"
                                    [(selectedOptions)]="contact_editors"
                                    optionLabel="full_name"
                                    optionValue="_id"
                                    placeholder="Select Editors"></re-multiSelect>
                                </div>
                                <div class="text-right">
                                  <button type="button" class="preview-btn" (click)="editContact(); own_cont.hide($event)">Update</button>
                                </div>
                              </div>
                              <div
                                *ngIf="
                                  selectedContact?.isPrivate &&
                                  (api.getUserId() === selectedContact?.user_id || selectedContact?.owners?.includes(api.getUserId())) &&
                                  selectedContact?.owner_requestors_name &&
                                  selectedContact?.owner_requestors?.length > 0
                                ">
                                <div class="form-group mt-3">
                                  <label class="mb-1">Owner Requests</label>
                                  <div class="d-block">
                                    <span class="f-14 text-primarys font-italic">{{ selectedContact?.owner_requestors_name }}</span>
                                  </div>
                                </div>
                              </div>
                              <div
                                *ngIf="
                                  selectedContact?.isPrivate &&
                                  (api.getUserId() === selectedContact?.user_id || selectedContact?.owners?.includes(api.getUserId()))
                                ">
                                <div class="form-group mt-3">
                                  <label class="mb-1">Transfer Ownership</label>
                                  <re-multiSelect
                                    [options]="staffOwner"
                                    [(selectedOptions)]="private_contact_owners"
                                    optionLabel="full_name"
                                    optionValue="_id"
                                    (onUpdate)="getContactList()"
                                    placeholder="Select Owners"></re-multiSelect>
                                </div>
                                <div class="text-right py-2">
                                  <button type="button" class="btn btn-primary btn-sm" (click)="ownContact(); own_cont.hide($event)">
                                    Update Transfer
                                  </button>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </p-overlayPanel>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="{{ selectedContact?.is_deleted ? 'mb-1' : 'mb-3' }} flex-between flex-wrap">
                  <div>
                    <p class="f-20" *ngIf="UserForm.get('type')?.value">
                      {{
                        UserForm.get('type')?.value === 'Company'
                          ? UserForm.get('company_name')?.value
                          : (UserForm.get('first_name')?.value || '') + ' ' + (UserForm.get('last_name')?.value || '')
                      }}
                    </p>
                  </div>
                  <div class="d-flex" *ngIf="lmService?.isEdit_show_div == 'edit_contact'">
                    <!-- type="button" — this row sits inside the contact form, so a
                         submit button here would save the contact instead. -->
                    <button
                      type="button"
                      class="_outline-btn ml-auto mr-2 btn-sm {{ dynamicPanelSizes[0] <= '35' ? 'mb-2' : '' }}"
                      *ngIf="!isPrivate"
                      (click)="openExternalEoiModal()"
                      pTooltip="Generate a secure EOI link for this contact"
                      tooltipPosition="top">
                      <i class="fa-solid fa-link mr-1"></i> EOI Link
                    </button>
                    <button
                      type="submit"
                      class="_outline-btn {{ isPrivate ? 'ml-auto' : '' }} mr-2 btn-sm {{ dynamicPanelSizes[0] <= '35' ? 'mb-2' : '' }}"
                      [disabled]="isPrivate"
                      [class.disabled]="submittedBtn"
                      (click)="createContact('onlyUpdate')">
                      Save
                    </button>
                    <ng-container *ngIf="lmService.tab_levels?.length === 1 && lmService?.isEdit_show_div == 'edit_contact'">
                      <button
                        type="submit"
                        class="_primary-btn ml-auto btn-sm"
                        [disabled]="isPrivate"
                        [class.disabled]="submittedBtn"
                        (click)="createContact('update')">
                        Save & Close
                      </button>
                    </ng-container>
                  </div>
                </div>
                <p class="mb-3 text-danger" *ngIf="selectedContact?.is_deleted">Contact deleted: restore from settings.</p>
                <div class="position-relative">
                  <app-collapse-box [headingClassName]="'f-14'" [heading]="'Contact Details'" [background]="true">
                    <div class="pb-2 pt-2" *ngIf="numOfNotValidFields > 0">
                      <p class="form-error font-weight-bold cursor-pointer" (click)="notDisplayRequiredMessage = false">
                        You have {{ numOfNotValidFields }} notifications. Select to view.
                      </p>
                      <div class="error-message" [ngClass]="{ 'd-none': notDisplayRequiredMessage }">
                        <ul>
                          <li
                            class="pb-1 cursor-pointer"
                            *ngFor="let message of requiredErrorMessages"
                            (click)="ActivateTabIndexByError(message.field)">
                            {{ message?.message | capitalizephrase }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <ng-container *ngIf="UserForm.controls['type'].value !== 'Company'; else has_company">
                        <div class="col-sm-4 col-md-4 col-lg-2">
                          <div class="form-group">
                            <label class="mb-1" for="lastname">Title</label>
                            <ng-select
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [items]="addTile"
                              [multiple]="false"
                              [searchable]="false"
                              [clearable]="false"
                              placeholder="Select"
                              formControlName="add_title"
                              [ngClass]="{ 'is-invalid': submitted && f.add_title.errors }"
                              [readonly]="isPrivate">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-5">
                          <div class="form-group">
                            <label class="mb-1" for="lastname">First Name<span title="Required">*</span></label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="first_name"
                              [readonly]="isPrivate"
                              [ngClass]="{
                                '_input-error': submitted && f.first_name.errors?.['required'],
                              }" />
                            <div *ngIf="submitted && f.first_name.invalid" class="ml-2 mt-1">
                              <p *ngIf="f.first_name.errors?.['required']" class="text-danger f-10">First name is required</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-5 col-sm-6 col-md-6">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Last Name</label>
                            <input type="text" class="site-input" formControlName="last_name" [readonly]="isPrivate" />
                          </div>
                        </div>
                        <div
                          class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-lg-6 col-sm-6 col-md-6' }}"
                          *ngIf="UserForm.controls['contact_type'].value?.toLowerCase() === 'agent'">
                          <div class="form-group">
                            <label class="mb-1" for="position">Position</label>
                            <ng-select
                              bindLabel="tag_name"
                              bindValue="tag_name"
                              [items]="companyRole"
                              [multiple]="false"
                              [searchable]="true"
                              [clearable]="true"
                              placeholder="Select Position"
                              formControlName="position"
                              class="primary-taged"
                              [readonly]="isPrivate">
                              <ng-template ng-option-tmp let-item="item">
                                <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div
                          class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-lg-6 col-sm-6 col-md-6' }}"
                          *ngIf="UserForm.controls['contact_type'].value?.toLowerCase() === 'agent'">
                          <div class="form-group">
                            <label class="mb-1" for="wechat">WeChat</label>
                            <input type="text" class="site-input" formControlName="wechat" [readonly]="isPrivate" />
                          </div>
                        </div>
                        <div class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-lg-6 col-sm-6 col-md-6' }}">
                          <div class="form-group">
                            <label class="mb-1" for="firstname">Preferred Name</label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="nick_name"
                              [readonly]="isPrivate"
                              [ngClass]="{ 'is-invalid': submitted && f.nick_name.errors }" />
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #has_company>
                        <div class="col-12 col-xl-12" *ngIf="UserForm.controls['type'].value === 'Company'">
                          <div class="form-group">
                            <label class="mb-1">Company Name <span title="Required">*</span></label>
                            <input
                              type="text"
                              class="site-input"
                              formControlName="company_name"
                              [readonly]="isPrivate"
                              [ngClass]="{
                                '_input-error': submitted && f.company_name.errors?.['required'],
                              }" />
                            <div *ngIf="submitted && f.company_name.invalid" class="ml-2 mt-1">
                              <p *ngIf="f.company_name.errors?.['required']" class="text-danger f-10">Company name is required</p>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <div class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-lg-6 col-sm-12 col-md-12' }}">
                        <div class="form-group mb-2">
                          <label class="mb-1" for="firstname">Preferred Contact Method</label>
                          <re-multiSelect
                            [options]="preferred_contact_method"
                            formControlName="preferred_contact_method"
                            optionLabel="tag_name"
                            optionValue="tag_name"
                            class="multiselect"
                            placeholder="Select Contact Method"></re-multiSelect>
                        </div>
                      </div>
                      <div
                        class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-lg-6 col-sm-12 col-md-12' }}"
                        *ngIf="UserForm.controls['type'].value == 'Company'">
                        <div class="form-group">
                          <label>Phone</label>
                          <input type="text" class="site-input" formControlName="telephone_no" [readonly]="isPrivate" />
                        </div>
                      </div>

                      <div class="{{ dynamicPanelSizes[0] <= '35' ? 'w-100' : 'col-sm-12 col-md-12 col-lg-6 col-xs-12 ' }}">
                        <div class="{{ dynamicPanelSizes[0] <= '35' ? 'w-100 d-flex' : 'row' }}">
                          <div class="{{ dynamicPanelSizes[0] <= '35' ? 'w-100 pr-2' : 'col-12 py-0' }} email__">
                            <div class="form-group mb-2">
                              <label for="email">Email <span title="Required">*</span></label>
                              <input
                                type="email"
                                class="site-input"
                                formControlName="email"
                                [readonly]="isPrivate"
                                [ngClass]="{
                                  '_input-error': submitted && (f.email.errors?.['required'] || f.email.errors?.['email']),
                                }" />
                              <div *ngIf="submitted && f.email.invalid" class="ml-2 mt-1">
                                <p *ngIf="f.email.errors?.['required']" class="text-danger f-10">Email is required</p>
                                <p *ngIf="f.email.errors?.['email']" class="text-danger f-10">Invalid email format</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="{{ dynamicPanelSizes[0] <= '35' ? 'w-100' : 'col-sm-12 col-md-12 col-lg-6 col-xs-12' }}"
                        *ngIf="UserForm.controls['type'].value !== 'Company'">
                        <div class="{{ isMobile ? 'mob__responsive' : 'd-flex' }}">
                          <div class="mb-2 form-group w-100">
                            <label *ngIf="!isMobile">Phone</label>
                            <input
                              type="text"
                              class="site-input {{ isMobile ? 'mt-3' : '' }}"
                              formControlName="mobile_no"
                              [readonly]="isPrivate"
                              appMobileMask
                              placeholder="0000 000 000"
                              [ngClass]="{ 'is-invalid': submitted && f.mobile_no.errors }" />
                            <div *ngIf="submitted && f.mobile_no.invalid" class="ml-2 mt-1">
                              <p *ngIf="f.mobile_no.errors?.['required']" class="text-danger f-10">Phone is required</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-lg-6 col-sm-12 col-md-12' }}"
                        *ngIf="UserForm.controls['type'].value == 'Company'">
                        <div class="form-group">
                          <label>Website</label>
                          <input type="text" class="site-input" formControlName="website" [readonly]="isPrivate" />
                        </div>
                      </div>
                      <div class="{{ dynamicPanelSizes[0] <= '35' ? 'col-sm-12' : 'col-lg-6 col-sm-12 col-md-12' }}">
                        <div class="form-group mb-2">
                          <label class="mb-1" for="sub_office_id">Sub Office</label>
                          <ng-select
                            [items]="subOfficeList"
                            bindLabel="office_name"
                            bindValue="_id"
                            [searchable]="true"
                            [clearable]="true"
                            placeholder="Select Sub Office"
                            formControlName="sub_office_id"
                            [readonly]="isPrivate"></ng-select>
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <app-contact-alternative-info
                          [items]="alternativeInfo"
                          [contactId]="primary_contact_id"
                          [isReadonly]="isPrivate"></app-contact-alternative-info>
                      </div>
                    </div>
                  </app-collapse-box>
                  <div class="mt-3">
                    <app-collapse-box [headingClassName]="'f-14'" [heading]="'Company'">
                      <div class="row">
                        <div *ngIf="UserForm.controls['type'].value !== 'Company'">
                          <div class="row align-items-end">
                            <div class="col-12 grio">
                              <label for="">
                                <re-multiselect
                                  [module]="'contacts'"
                                  [type]="'Company'"
                                  [placeholder]="'Select'"
                                  [truncate]="25"
                                  [isMultiple]="false"
                                  [isCreateNew]="true"
                                  [isClear]="true"
                                  [isEmail]="true"
                                  [isFullObject]="true"
                                  [escapeOverflow]="true"
                                  (createNew)="openRightModal(null, 'add_contact')"
                                  [selected_ids]="companies"
                                  (onUpdate)="selectCompany($event)"
                                  [style]="{ width: '100%' }"></re-multiselect>
                              </label>
                              <button class="_outline-btn" (click)="attachCompany()" [class.disabled]="loading" [disabled]="isPrivate">
                                Associate
                              </button>
                            </div>
                          </div>
                          <p class="f-10 mt-1 ml-3">When creating a new Company, press Save and not Save and Close</p>
                          <ng-container *ngIf="attach_company.length > 0 && UserForm.controls['type'].value !== 'Company'">
                            <div class="row mt-2 ml-1">
                              <div *ngFor="let company of attach_company" class="col-auto">
                                <div class="company-div">
                                  <span class="f-12 cursor-pointer" (click)="openRightModal(company, 'edit_contact')">{{
                                    company?.company_name
                                  }}</span>
                                  <i
                                    class="pi pi-times-circle ml-2 f-12 cursor-pointer"
                                    (click)="deleteCompany(company?._id, company?.company_name)"></i>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>

                        <div class="col-12 {{ UserForm.controls['type'].value == 'Company' ? 'pt-0' : '' }}">
                          <div class="searching-address {{ UserForm.controls['type'].value == 'Company' && !isMobile ? 'extra_space' : '' }}">
                            <div class="all-address-fields">
                              <p-accordion>
                                <p-accordionTab [selected]="true">
                                  <div class="row mt-4">
                                    <h4 class="mb-2 f-14 _fw-500">Address</h4>
                                    <div class="col-xl-11 mb-3">
                                      <input
                                        class="site-input b-none"
                                        [readonly]="isPrivate"
                                        placeholder="Search Address"
                                        google-places-autocomplete
                                        [options]="options"
                                        (onAddressChange)="handleAddressChange($event)"
                                        formControlName="contact_address"
                                        [ngClass]="{
                                          '_input-error': submitted && f.contact_address.errors,
                                        }" />
                                    </div>
                                    <div class="col-sm-1 pl-0">
                                      <button
                                        id="toggle-overlay"
                                        class="_addNew ml-2 mt-0"
                                        (click)="openAddressOverlayPanel($event)"
                                        [class.disabled]="disablePropertyAddress">
                                        <img [src]="common_images?.pencil_icon" class="pencil-cross" width="12" />
                                        <div class="position-relative">
                                          <p-overlayPanel
                                            #ops
                                            [style]="{ width: '500px' }"
                                            appendTo="body"
                                            styleClass="contact-address"
                                            [baseZIndex]="10000"
                                            [autoZIndex]="true"
                                            [dismissable]="true"
                                            [showCloseIcon]="true">
                                            <ng-template pTemplate>
                                              <div class="row">
                                                <div class="col-lg-12 mb-4 d-flex align-items-center justify-content-between">
                                                  <h4 class="f-12 _fw-600">Address</h4>
                                                  <button class="_primary-btn" (click)="updateAddress(); ops.hide($event)">Save</button>
                                                </div>
                                                <div class="col-xl-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Building Name</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.building_name.errors }"
                                                      class="_input"
                                                      formControlName="building_name" />
                                                  </div>
                                                </div>
                                                <div class="col-lg-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Unit No</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.unit_no.errors }"
                                                      class="_input"
                                                      formControlName="unit_no" />
                                                  </div>
                                                </div>
                                                <div class="col-lg-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Street No</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.street_no.errors }"
                                                      class="_input"
                                                      formControlName="street_no" />
                                                  </div>
                                                </div>
                                                <div class="col-xl-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Street Name</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.street_name.errors }"
                                                      class="_input"
                                                      formControlName="street_name" />
                                                  </div>
                                                </div>
                                                <div class="col-xl-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Suburb</p>
                                                    <div class="auto-complete-custom">
                                                      <p-autoComplete
                                                        formControlName="suburb"
                                                        [virtualScroll]="true"
                                                        class="hide-loader"
                                                        [bufferAmount]="10"
                                                        [suggestions]="filteredItems"
                                                        [ngClass]="{ '_input-error': submitted && f.suburb.errors }"
                                                        [itemSize]="34"
                                                        (completeMethod)="filterItems($event)"
                                                        field="suburb">
                                                      </p-autoComplete>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col-lg-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">State</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.state.errors }"
                                                      class="_input"
                                                      formControlName="state" />
                                                  </div>
                                                </div>
                                                <div class="col-lg-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Post Code</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.post_code.errors }"
                                                      class="_input"
                                                      formControlName="post_code" />
                                                  </div>
                                                </div>
                                                <div class="col-xl-6 mb-2">
                                                  <div class="form-group">
                                                    <p class="f-12 mb-2">Country</p>
                                                    <input
                                                      type="text"
                                                      [ngClass]="{ '_input-error': submitted && f.country.errors }"
                                                      class="_input"
                                                      formControlName="country" />
                                                  </div>
                                                </div>
                                              </div>
                                            </ng-template>
                                          </p-overlayPanel>
                                        </div>
                                      </button>
                                    </div>
                                  </div>
                                </p-accordionTab>
                              </p-accordion>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="px-3 py-1 tag_section">
                        <div class="mt-2 mb-2 d-flex justify-content-between align-items-center">
                          <h4 class="f-14 _fw-500">Tags</h4>
                          <i class="pi pi-plus cursor-pointer f-12 ml-2 text-primary" (click)="handleTabs('clickView')"></i>
                        </div>
                        <div
                          cdkDropList
                          #doneList="cdkDropList"
                          [cdkDropListData]="todo"
                          [cdkDropListConnectedTo]="['todoList', 'todoList_2']"
                          class="example-list"
                          (cdkDropListDropped)="dropTag($event)"
                          class="d-flex align-items-center flex-wrap tags-container pr-2 pt-2 pb-1"
                          *ngIf="todo?.length > 0">
                          <div
                            class="contact-tags mr-2 mb-1 f-12 primary-chip cp p-chip d-inline-flex align-items-center todo_padding"
                            *ngFor="let item of todo; let i = index"
                            [pTooltip]="item?.type">
                            <div class="p-chip-text">{{ item?.tag_name }}</div>
                            <i class="f-12 pi pi-times cp ml-2" (click)="removePublicTag(i)"></i>
                          </div>
                        </div>
                      </div>
                    </app-collapse-box>
                  </div>
                </div>
              </div>
              <div class="mt-3 tab-pane fade show active position-relative" *ngIf="!isPrivate">
                <app-collapse-box [headingClassName]="'f-14'" [heading]="'Marketing Info'">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group mb-0">
                        <label for="gender">Gender</label>
                        <div class="d-flex align-items-center mt-2 flex_wrap">
                          <div class="d-flex align-items-center p-field-radiobutton">
                            <p-radioButton
                              name="gender"
                              value="Male"
                              formControlName="gender"
                              [disabled]="isPrivate"
                              p-radiobutton-icon="pi pi-check"
                              [ngClass]="{ '_input-error': submitted && f.gender.errors }">
                            </p-radioButton>
                            <label for="gender" class="pl-2">Male</label>
                          </div>
                          <div class="d-flex align-items-center p-field-radiobutton mx-4">
                            <p-radioButton
                              name="gender"
                              value="Female"
                              formControlName="gender"
                              [disabled]="isPrivate"
                              [ngClass]="{ '_input-error': submitted && f.gender.errors }">
                            </p-radioButton>
                            <label for="gender" class="pl-2">Female</label>
                          </div>
                          <div class="d-flex align-items-center p-field-radiobutton">
                            <p-radioButton
                              name="gender"
                              value="not_prefer"
                              formControlName="gender"
                              [disabled]="isPrivate"
                              [ngClass]="{ '_input-error': submitted && f.gender.errors }">
                            </p-radioButton>
                            <label for="not_prefer" class="pl-2">Prefer not to say</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2 w-130">
                      <div class="form-group mb-0">
                        <label class="mb-1" for="">Birthday</label>
                        <div class="w-100">
                          <p-inputMask
                            mask="99/99/9999"
                            formControlName="birthday"
                            placeholder="DD/MM/YYYY"
                            slotChar="dd/mm/yyyy"
                            firstDayOfWeek="1"
                            [disabled]="isPrivate"
                            [ngClass]="{
                              '_input-error': submitted && f.birthday.errors,
                            }"></p-inputMask>
                        </div>
                      </div>
                    </div>
                  </div>
                </app-collapse-box>
              </div>
            </div>

            <div class="text-right mt-4">
              <div *ngIf="lmService?.isEdit_show_div == 'edit_contact'">
                <button
                  type="submit"
                  class="_outline-btn ml-auto mr-2 btn-sm"
                  [disabled]="isPrivate"
                  [class.disabled]="submittedBtn"
                  (click)="createContact('onlyUpdate')">
                  Save
                </button>
                <ng-container *ngIf="lmService.tab_levels?.length === 1">
                  <button
                    type="submit"
                    class="_primary-btn ml-auto btn-sm"
                    [disabled]="isPrivate"
                    [class.disabled]="submittedBtn"
                    (click)="createContact('update')">
                    Save & Close
                  </button>
                </ng-container>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #splitter2>
  <div class="col-lg-12 position-relative {{ isMobile ? '' : 'cs-b-left' }}">
    <ng-container *ngIf="userRole == 'master admin' || userRole == 'operations manager' || userPermission.includes('contact_process.view')">
      <img
        [src]="common_images?.automation_icon"
        *ngFlag="'automation'"
        [ngClass]="{ 'icon-red': no_process_run === true }"
        class="process-setting"
        (click)="GetListingWorkflowProcesses()" />
    </ng-container>
    <div class="property-details border-none {{ isMobile ? 'cs-mobile-padding mb-3' : 'cs-padding' }}">
      <div class="d-flex align-items-center primary-tabs b-b-tabs">
        <div class="mobile-tab mb-3" *ngIf="isMobile">
          <p (click)="showMenu = !showMenu">
            <img [src]="selectedItem.icon" class="mr-1" width="15px" class="selected_img" />
            {{ selectedItem ? selectedItem.label : 'Property Detail' }}
          </p>
          <i class="pi pi-chevron-down f-14 mobile-tab-icon cursor-pointer" (click)="showMenu = !showMenu"></i>
          <!-- Mobile Dropdown Menu -->
          <ng-container *ngIf="showMenu">
            <ul class="mobile-tab-menu">
              <ng-container *ngFor="let tab of tabs; let i = index">
                <li (click)="selectItem(tab)" *ngFlag="tab.flag">
                  <img [src]="tab.icon" class="mr-1" width="15px" />
                  {{ tab.label }}
                  <span class="badge" *ngIf="getBadgeCount(tab)">
                    {{ getBadgeCount(tab) }}
                  </span>
                </li>
              </ng-container>
            </ul>
          </ng-container>
        </div>

        <ul class="nav nav-pills tools-tab-nav w-100 align-items-end" role="tablist" *ngIf="!isMobile">
          <ng-container *ngFor="let tab of tabs; let i = index">
            <li
              *ngFlag="tab.flag"
              class="nav-item cursor-pointer"
              role="presentation"
              [hidden]="!isTabVisible(tab)"
              (click)="rightActiveIndex = tab.panel; onChangeRightPanel(tab.label)">
              <a
                [ngClass]="{ active: rightActiveIndex === tab.panel }"
                [id]="'pills-' + tab.id"
                data-bs-toggle="pill"
                [attr.data-bs-target]="'#' + tab.id"
                role="tab"
                [attr.aria-controls]="tab.id"
                [attr.aria-selected]="rightActiveIndex === tab.panel">
                <img [src]="tab.icon" class="mr-1" width="15px" />
                {{ tab.label }}
                <p class="f-10 ml-2 a-head-badge" *ngIf="getBadgeCount(tab)">
                  {{ getBadgeCount(tab) }}
                </p>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade {{ rightActiveIndex === 0 && 'show active' }}"
          *ngIf="!isPrivate"
          [id]="'cStream' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cStream' + tabIndex + '-tab'"
          tabindex="0">
          <div class="position-relative">
            <div class="s-custom-entity-records scroll_ overflow-auto pr-2 mxh-700" (scroll)="onStreamScroll($event)" #streamScrollableElement>
              <i class="pi pi-arrow-up" (click)="streamScrollToTop()" *ngIf="streamScrollTop > 50"></i>
              <ng-container>
                <div class="{{ isMobile ? 'd-block' : 'd-flex' }} align-items-center justify-content-between">
                  <div class="filter-by-tasks stream_search">
                    <div class="position-relative mr-2 w-100">
                      <input
                        type="text"
                        [(ngModel)]="keyword"
                        id="keywordInput"
                        (input)="searchStream($event)"
                        class="_input-icon"
                        placeholder="Search by keyword" />
                      <i class="pi pi-search _search-icon"></i>
                      <i class="pi pi-times _cross-icon" *ngIf="keyword && !isSearching" (click)="keyword = ''; streams = []; getStream()"></i>
                      <!-- <img [src]="common_images?.loader_gif" alt="loader" class="loader-gif" *ngIf="isSearching" /> -->
                    </div>
                  </div>
                  <div class="mr-1 {{ isMobile ? 'mb-3' : '' }}">
                    <p *ngIf="streams?.length > 0">
                      {{ 'Records: ' + totalRecord }}
                    </p>
                  </div>
                </div>
                <div class="stream-overflow" *ngIf="streams?.length">
                  <ng-container *ngFor="let itm of streams">
                    <ng-container *ngIf="itm.type == 'property_appointment'">
                      <div class="stream-body b-light-bottom">
                        <div class="d-flex align-items-end my-3">
                          <div>
                            <div class="d-flex align-items-center mb-2">
                              <i class="pi pi-calendar f-16 mr-2" aria-hidden="true"></i>
                              <p class="f-12 mr-2 _fw-600 text-capitalize">
                                <span>{{ itm?.summary }} </span>
                              </p>
                            </div>
                            <div class="d-flex align-items-center">
                              <i class="pi pi-map-marker f-16 mr-2" aria-hidden="true"></i>
                              <p class="f-12 _fw-600">
                                <span>{{ itm?.misc?.event?.location }}</span>
                              </p>
                            </div>
                          </div>
                          <span class="f-10 ml-auto text-dark">
                            {{
                              parseDate(itm?.created_at)
                                | date
                                  : 'EEE d MMM y h:mm
                            a'
                            }}</span
                          >
                        </div>
                        <div>
                          <div class="align-items-center justify-content-between mb-1">
                            <div class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}">
                              <div class="col-sm-2">
                                <p class="mb-2 f-12"><span>Type</span></p>
                                <p class="mb-2 f-12"><span>Start</span></p>
                                <p class="mb-2 f-12"><span>End</span></p>
                              </div>
                              <div class="col-sm-10">
                                <p class="mb-2 f-12">{{ itm?.misc?.type }}&nbsp;</p>
                                <p class="mb-2 f-12 text-dark">
                                  {{
                                    itm?.misc?.event?.start?.dateTime
                                      | date
                                        : 'EEE d MMM y
                                  h:mm a'
                                  }}&nbsp;
                                </p>
                                <p class="mb-2 f-12 text-dark">
                                  {{
                                    itm?.misc?.event?.end?.dateTime
                                      | date
                                        : 'EEE d MMM y
                                  h:mm a'
                                  }}&nbsp;
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="itm.type == 'LeadContact'">
                      <div class="stream-body b-light-bottom">
                        <div>
                          <div class="{{ isMobile ? 'd-block' : 'd-flex' }} align-items-center my-3">
                            <i class="pi pi-circle-on f-16 mr-2 {{ itm?.lead_status?.toLowerCase().replaceAll(' ', '-') }}" aria-hidden="true"></i>
                            <p class="f-12 _fw-600 text-capitalize">
                              <span>{{ itm?.summary }}</span> {{ itm?.lead_status }}
                            </p>
                            <span class="f-10 ml-auto text-dark">
                              {{
                                parseDate(itm?.created_at)
                                  | date
                                    : 'EEE d MMM y
                              h:mm a'
                              }}</span
                            >
                          </div>
                        </div>
                        <div>
                          <div class="d-flex align-items-center justify-content-between mb-3">
                            <a class="f-12 view_lead" href="javascript:void(0)" (click)="_editLead(itm?.lead_id)">View Lead</a>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="itm.type == 'relatedcontacts'">
                      <div class="stream-body b-light-bottom">
                        <div>
                          <div class="{{ isMobile ? 'd-block' : 'd-flex' }} align-items-end my-3 Relationship-work">
                            <i class="pi pi-map-marker f-16 mr-2" aria-hidden="true"></i>
                            <p class="f-12 _fw-600 text-capitalize">
                              <span>{{ itm?.summary }}</span>
                              {{ itm?.property?.property_address }}
                            </p>
                            <span class="f-10 ml-auto text-dark">
                              {{ parseDate(itm?.created_at) | date: 'EEE d MMM y h:mm a' }}
                            </span>
                          </div>
                        </div>
                        <div>
                          <div class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}">
                            <p class="col-sm-2 f-10 des-date-time-color">Name</p>
                            <p class="col-sm-10 f-10 des-date-time-color">{{ itm?.name }}</p>
                          </div>
                          <div
                            class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}"
                            *ngIf="itm?.misc?.relation?.length > 0">
                            <p class="col-sm-2 f-10 des-date-time-color">Relationship</p>
                            <p class="col-sm-10 f-10 des-date-time-color">
                              {{ itm?.misc?.relation?.toString().replaceAll(',', ', ') }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!['property_appointment', 'LeadContact', 'relatedcontacts'].includes(itm.type)">
                      <div *ngIf="itm.record_source == 'history'" class="stream-body b-light-bottom">
                        <div *ngIf="itm.apt">
                          <div class="d-flex align-items-end my-3">
                            <img class="img-20 dark mr-2 mt_minus" [src]="common_images?.contact_lead_icon" />
                            <div class="d-flex">
                              <div>
                                <p class="f-12 _fw-600 text-capitalize">
                                  <span>{{ itm?.summary }}</span>
                                </p>
                                <div [innerHTML]="itm?.desc"></div>
                              </div>
                            </div>
                            <span class="f-10 text-capitalize ml-auto des-date-time-color text-dark">{{
                              itm?.created_at | date: 'EEE d MMM y h:mm a'
                            }}</span>
                          </div>
                        </div>
                        <div *ngIf="!itm.apt">
                          <div class="{{ isMobile ? 'd-block' : 'd-flex' }} align-items-center my-3">
                            <i class="pi pi-map-marker f-16 mr-2" aria-hidden="true"></i>
                            <p class="f-12 _fw-600 text-capitalize">
                              <span>{{ itm?.summary }}</span>
                              {{ itm?.property?.property_address }}
                            </p>
                            <span class="f-10 ml-auto text-dark">{{ itm?.created_at | date: 'EEE d MMM y h:mm a' }}</span>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="itm.record_source != 'history'" class="stream-body b-light-bottom">
                        <div>
                          <div class="{{ isMobile ? 'd-block' : 'd-flex' }} align-items-end my-3 history-work">
                            <i class="pi pi-map-marker f-16 mr-2" aria-hidden="true"></i>
                            <p class="f-12 _fw-600 text-capitalize">
                              <span>{{ itm?.summary }}</span>
                              {{ itm?.property?.property_address }}
                            </p>
                            <span class="f-10 ml-auto text-dark">
                              {{
                                parseDate(itm?.created_at)
                                  | date
                                    : 'EEE d MMM y
                              h:mm a'
                              }}</span
                            >
                          </div>
                        </div>
                        <div>
                          <div class="align-items-center justify-content-between mb-1">
                            <div class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}">
                              <p class="col-sm-2 f-10 des-date-time-color">Detail</p>
                              <p class="col-sm-10 f-10 des-date-time-color">{{ itm?.detail }}</p>
                            </div>
                            <div
                              class="{{ isMobile ? 'd-flex align-items-senter justify-content-between' : 'row' }}"
                              *ngIf="itm?.object == 'PropertyContact'">
                              <p class="col-sm-2 f-10 des-date-time-color">Relationship</p>
                              <p class="col-sm-10 f-10 des-date-time-color">
                                {{ itm?.misc?.type?.toString().replaceAll(',', ', ') }}
                              </p>
                            </div>
                            <div class="row" *ngIf="itm?.collection != 'property_contact'">
                              <p class="col-sm-2 f-10 des-date-time-color">{{ itm?.type === 'lead' ? 'Association' : 'Description' }}</p>
                              <p class="col-sm-10 f-10 des-date-time-color">{{ itm?.type === 'lead' ? itm?.desc : itm?.desc2 }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
          <ng-container *ngIf="!streams?.length">
            <div class="d-flex align-items-center">
              <img [src]="common_images?.stream_new" class="email-connect mr-4" />
              <p class="f-12">No Updates Yet</p>
            </div>
          </ng-container>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 1 && 'show active' }}"
          *ngIf="!isPrivate"
          [id]="'cLead' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cLead' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container *ngIf="stats['totalLeads']?.length">
            <div>
              <div class="d-flex align-items-center justify-content-between flex-wrap w-100 my-2">
                <p class="f-12 _fw-600">Records: {{ stats['totalLeads']?.length }}</p>
                <button *ngxPermissionsOnly="['lead.add']" class="_outline-btn ml-auto" (click)="newLead()">
                  <i class="pi pi-plus mr-2 f-12 text-primary"></i> New Lead
                </button>
              </div>
              <div class="position-relative w-100">
                <div class="s-custom-entity-records scroll_landing_page" (scroll)="onSideLeadScroll($event)" #sideLeadScrollableElement>
                  <i class="pi pi-arrow-up" (click)="sideLeadScrollToTop()" *ngIf="sideLeadScrollTop > 50"></i>
                  <p-table id="customentitydatalist" [value]="stats['totalLeads']" dataKey="_id" [rowHover]="false" [rows]="sideLeadRows">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="lead_th_1">&nbsp;</th>
                        <th class="lead_th_2">Date</th>
                        <th class="lead_th_3">Status</th>
                        <th class="lead_th_4">Listing/Projects</th>
                        <th class="lead_th_5">Lead Source</th>
                        <th class="lead_th_6">Agent</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-lead>
                      <tr class="cp">
                        <td class="lead_td_1">
                          <ng-container *ngIf="isAllowEdit(lead)">
                            <img
                              [src]="images?.people_add_user"
                              alt="user-minus"
                              width="16px"
                              class="cursor-pointer mr-3"
                              pTooltip="Remove Assigned"
                              (click)="removeAssignment(lead)" />
                            <i class="cursor-pointer f-16 pi pi-clone" pTooltip="Duplicate" (click)="duplicateRecords(lead)"></i>
                          </ng-container>
                        </td>
                        <td
                          class="lead_td_2"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.created_at | date: 'dd/MM/yy' }}
                        </td>
                        <td
                          class="lead_td_2"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          style="white-space: normal !important"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.lead_status }}
                        </td>
                        <td
                          class="lead_td_2"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.property ? lead?.property : lead?.project }}
                        </td>
                        <td
                          class="lead_td_2"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.lead_source }}
                        </td>
                        <td
                          class="lead_td_2"
                          (click)="editLead(lead)"
                          class="text-ellipsis"
                          [ngStyle]="{
                            'font-weight': lead?.is_read === false ? 'bold' : 'normal',
                          }">
                          {{ lead?.agent_responsible }}
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="5">No record found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="d-flex align-items-center flex-wrap w-100 justify-content-between" *ngIf="!stats['totalLeads']?.length">
            <div class="d-flex align-items-center">
              <img [src]="common_images?.enquiry" class="w-50px" />
              <p class="f-12">Assign leads to one contact.</p>
            </div>
            <button *ngxPermissionsOnly="['lead.add']" class="_outline-btn mt-2" (click)="newLead()">
              <i class="pi pi-plus mr-2 f-12 text-primary"></i> New Lead
            </button>
          </div>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 2 && 'show active' }}"
          *ngIf="!isPrivate"
          [id]="'cAppointments' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cAppointments' + tabIndex + '-tab'"
          tabindex="0">
          <div class="d-flex align-items-center primary-tabs b-b-tabs">
            <ul class="nav tools-tab-nav w-100 align-items-end" role="tablist">
              <li class="nav-item cursor-pointer" role="presentation">
                <a
                  class="active pl-0"
                  [id]="'pills-project_appointments' + tabIndex + '-tab'"
                  data-bs-toggle="pill"
                  (click)="appointmentTab = 0; getProjectAppointments()"
                  [attr.data-bs-target]="'#project_appointments' + tabIndex"
                  role="tab"
                  [attr.aria-controls]="'project_appointments' + tabIndex"
                  aria-selected="true">
                  Project
                </a>
              </li>
              <li class="nav-item cursor-pointer" role="presentation">
                <a
                  class=""
                  [id]="'pills-listing_appointment' + tabIndex + '-tab'"
                  data-bs-toggle="pill"
                  (click)="appointmentTab = 1; getListingAppointments()"
                  [attr.data-bs-target]="'#listing_appointment' + tabIndex"
                  role="tab"
                  [attr.aria-controls]="'listing_appointment' + tabIndex"
                  aria-selected="false">
                  Listing
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade {{ appointmentTab === 0 && 'show active' }}"
              [id]="'project_appointments' + tabIndex"
              role="tabpanel"
              [attr.aria-labelledby]="'pills-project_appointments' + tabIndex + '-tab'"
              tabindex="0">
              <div class="position-relative scroll_landing_page mt-2">
                <p-table [value]="project_appointment_list">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 150px">Project</th>
                      <th class="w-300p">Appointment Time</th>
                      <th>Agent</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-appointment>
                    <tr class="cursor-pointer">
                      <td>{{ appointment?.project_name }}</td>
                      <td>
                        <p>
                          {{ appointment.event.start.dateTime | date: 'd MMM y' }}
                          {{ appointment.start_time }} - {{ appointment.end_time }}
                        </p>
                      </td>
                      <td>
                        <ng-container *ngFor="let type of appointment?.agents">
                          <p-chip styleClass="my-1 mr-1 f-10 my-chip" [label]="type?.full_name" [removable]="false"></p-chip>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="3">No record found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
            <div
              class="tab-pane fade {{ appointmentTab === 1 && 'show active' }}"
              [id]="'listing_appointment' + tabIndex"
              role="tabpanel"
              [attr.aria-labelledby]="'pills-listing_appointment' + tabIndex + '-tab'"
              tabindex="0">
              <div class="position-relative scroll_landing_page mt-2">
                <p-table [value]="listing_appointment_list">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="w-300p">Listing</th>
                      <th class="w-300p">Appointment Time</th>
                      <th>Agent</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-appointment>
                    <tr class="cursor-pointer">
                      <td>{{ appointment?.property_address }}</td>
                      <td>
                        <p>
                          {{ appointment.event.start.dateTime | date: 'd MMM y' }}
                          {{ appointment.start_time }} - {{ appointment.end_time }}
                        </p>
                      </td>
                      <td>
                        {{ appointment?.agent?.full_name }}
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="3">No record found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 3 && 'show active' }}"
          *ngIf="!isPrivate"
          [id]="'cTasks' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cTasks' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container>
            <div class="contactTabTasks">
              <div *ngIf="!fullList?.length">
                <div class="d-flex w-400px align-items-center">
                  <img [src]="images?.contact_task" class="w-50px" />
                  <p class="l-h-1-31 f-12">Create tasks to associate with this contact.</p>
                </div>
              </div>
              <div class="ml-2">
                <p *ngIf="fullList?.length > 0">
                  {{ 'Records: ' + fullList?.length }}
                </p>
              </div>
              <button *ngxPermissionsOnly="['task.create']" class="_outline-btn mt-1 mb-2 ml-auto" (click)="addNewTask(null, true)">
                <i class="pi pi-plus mr-2 f-12 text-primary"></i> New Task
              </button>
            </div>
            <div class="position-relative history" *ngIf="fullList?.length > 0">
              <div class="s-custom-entity-records scrol_ mxh-500" (scroll)="onSideTaskScroll($event)" #sideTaskScrollableElement>
                <i class="pi pi-arrow-up" (click)="sideTaskScrollToTop()" *ngIf="sideTaskScrollTop > 50"></i>
                <p-table
                  id="customentitydatalist"
                  [value]="fullList"
                  dataKey="_id"
                  [rowHover]="false"
                  [rows]="sideTaskRows"
                  (sortFunction)="lmService.customSort($event)"
                  [customSort]="true">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="w-40px"></th>
                      <th>Title</th>
                      <th>Job Type</th>
                      <th>Task Status</th>
                      <th>Due Date</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-task>
                    <tr>
                      <td>
                        <i class="pi pi-exclamation-triangle" *ngIf="task?.is_exclamation"></i>
                      </td>
                      <td class="cursor-pointer" (click)="addNewTask(task, false)">
                        {{ task?.title }}
                      </td>
                      <td class="cursor-pointer" (click)="addNewTask(task, false)">
                        {{ task?.jobTypeName }}
                      </td>
                      <td class="cursor-pointer" (click)="addNewTask(task, false)">
                        {{ task?.taskStatusName }}
                      </td>
                      <td class="cursor-pointer" (click)="addNewTask(task, false)">
                        {{ task?.due_date | date: 'dd/MM/yy' }}
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="5">No record found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </ng-container>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 4 && 'show active' }}"
          *ngIf="!isPrivate"
          [id]="'rProperty' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-rProperty' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container>
            <div class="d-flex align-items-center primary-tabs b-b-tabs">
              <ul class="nav tools-tab-nav w-100 align-items-end" role="tablist">
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="active pl-0"
                    [id]="'pills-listing' + tabIndex + '-tab'"
                    data-bs-toggle="pill"
                    (click)="rPropActiveIndex = 1"
                    [attr.data-bs-target]="'#listing' + tabIndex"
                    role="tab"
                    [attr.aria-controls]="'listing' + tabIndex"
                    aria-selected="true">
                    <img [src]="images?.contact_stream" alt="Listing" width="14px" class="mr-1" />
                    Listing
                    <p class="f-10 ml-2 a-head-badge" *ngIf="attached_listing?.length > 0">
                      {{ attached_listing?.length }}
                    </p>
                  </a>
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class=""
                    [id]="'pills-property' + tabIndex + '-tab'"
                    data-bs-toggle="pill"
                    (click)="rPropActiveIndex = 2"
                    [attr.data-bs-target]="'#property' + tabIndex"
                    role="tab"
                    [attr.aria-controls]="'property' + tabIndex"
                    aria-selected="false">
                    <img [src]="common_images?.home" alt="Property" width="14px" class="mr-1" />
                    Property
                    <p class="f-10 ml-2 a-head-badge" *ngIf="attached_properties?.length > 0">
                      {{ attached_properties?.length }}
                    </p>
                  </a>
                </li>
                <li class="nav-item cursor-pointer" role="presentation" *ngFlag="'contracts'">
                  <a
                    class=""
                    [id]="'pills-contract' + tabIndex + '-tab'"
                    data-bs-toggle="pill"
                    (click)="rPropActiveIndex = 4"
                    [attr.data-bs-target]="'#contract' + tabIndex"
                    role="tab"
                    [attr.aria-controls]="'contract' + tabIndex"
                    aria-selected="false">
                    <img [src]="images?.contact_contract" alt="Contract" width="14px" class="mr-1" />
                    Contract
                    <p class="f-10 ml-2 a-head-badge" *ngIf="attached_contracts?.length > 0">
                      {{ attached_contracts?.length }}
                    </p>
                  </a>
                </li>
              </ul>
            </div>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade {{ rPropActiveIndex === 1 && 'show active' }}"
                [id]="'listing' + tabIndex"
                role="tabpanel"
                [attr.aria-labelledby]="'pills-listing' + tabIndex + '-tab'"
                tabindex="0">
                <div class="d-flex align-items-center my-3">
                  <div class="w-100 pr-3">
                    <span class="p-input-icon-left w-100">
                      <i class="pi pi-search search_i"></i>
                      <p-autoComplete
                        class="autocomplete-icon"
                        [(ngModel)]="attach_listing"
                        [virtualScroll]="false"
                        [suggestions]="filteredListing"
                        field="property_address"
                        (completeMethod)="searchListing($event)"
                        (onSelect)="listingSelection($event)"
                        placeholder="Search Listing">
                      </p-autoComplete>
                    </span>
                  </div>
                  <div>
                    <button class="preview-btn btn-sm f-12" (click)="attachListing()" [class.disabled]="listingBtnDisable">Associate</button>
                  </div>
                </div>
                <div class="mb-2" *ngIf="!filteredListing?.length && property_search_complete">
                  <a class="custom-a f-12" href="javascript:void(0)" (click)="openRightModal(null, 'add_property')">
                    <i class="pi pi-plus f-10 mr-2"></i>Add New Property
                  </a>
                </div>
                <div class="contact-tags w-100" *ngIf="attached_listing?.length">
                  <div class="p-3 contact_type">
                    <p class="f-12 font-weight-bold">Contact Type</p>
                    <div
                      class="d-flex align-items-center flex-wrap"
                      *ngIf="contactType"
                      cdkDropList
                      [cdkDropListConnectedTo]="getListingConnectedTo()">
                      <span class="related-tag primary-chip" *ngFor="let tag of contactType" cdkDrag [cdkDragData]="tag.tag_name">
                        <span class="p-tag-value">{{ tag.tag_name }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="p-3 mt-4 contact_type">
                    <p class="f-12 font-weight-bold">Related Tags</p>
                    <div
                      class="d-flex align-items-center flex-wrap"
                      *ngIf="relatedContactTags"
                      cdkDropList
                      [cdkDropListConnectedTo]="getListingConnectedTo()">
                      <span class="related-tag primary-chip" *ngFor="let tag of relatedContactTags" cdkDrag [cdkDragData]="tag.tag_name">
                        <span class="p-tag-value">{{ tag.tag_name }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="position-relative mt-3">
                  <div class="s-custom-entity-records scrol_ history mxh-300" (scroll)="onSideListingScroll($event)" #sideListingScrollableElement>
                    <i class="pi pi-arrow-up" (click)="sideListingScrollToTop()" *ngIf="sideListingScrollTop > 50"></i>
                    <p-table
                      styleClass="pagination-dropdown"
                      scrollWidth="100%"
                      dataKey="_id"
                      [value]="attached_listing"
                      [paginator]="false"
                      [rows]="sideListingRows"
                      [(selection)]="selectedRows">
                      <ng-template pTemplate="header">
                        <tr>
                          <th class="px-0 w-10px"></th>
                          <th pSortableColumn="type">Tags<p-sortIcon field="type" class="ml-2"></p-sortIcon></th>
                          <th pSortableColumn="property.property_address">
                            Address<p-sortIcon field="property.property_address" class="ml-2"></p-sortIcon>
                          </th>
                          <th pSortableColumn="property.property_status">
                            Status<p-sortIcon field="property.property_status" class="ml-2"></p-sortIcon>
                          </th>
                          <th pSortableColumn="property.value">Price<p-sortIcon field="property.value" class="ml-2"></p-sortIcon></th>
                          <th pSortableColumn="property.contract_status">
                            Created Date<p-sortIcon field="property.contract_status" class="ml-2"></p-sortIcon>
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-listing>
                        <tr>
                          <td class="pl-0">
                            <button class="btn p-0" (click)="deleteAttachedListing(listing?._id, 'listing')">
                              <img [src]="common_images?.delete_icon" alt="delete" width="16px" />
                            </button>
                          </td>
                          <td
                            cdkDropList
                            [id]="'s_' + listing?._id"
                            [cdkDropListData]="listing['type']"
                            (cdkDropListDropped)="dropListing($event, listing)">
                            <div class="listing-tags">
                              <ng-container *ngFor="let tag of listing['type']">
                                <p-chip styleClass="mr-1 f-10 primary-chip">
                                  <span class="p-chip-text">{{ tag }}</span>
                                  <i class="pi pi-times f-10 ml-1 cursor-pointer" (click)="removelistingTag(tag, listing)"></i>
                                </p-chip>
                              </ng-container>
                            </div>
                          </td>
                          <td
                            class="cursor-pointer text-captilize"
                            [style]="{ 'white-space': 'normal !important' }"
                            (click)="openRightModal(listing?.property, 'edit_listing_property')">
                            {{ listing?.property.property_address }}
                          </td>
                          <td class="cursor-pointer text-captilize" (click)="openRightModal(listing?.property, 'edit_listing_property')">
                            {{ listing?.property.property_status }}
                          </td>
                          <td class="cursor-pointer text-captilize" (click)="openRightModal(listing?.property, 'edit_listing_property')">
                            <span *ngIf="listing?.property?.value">{{ listing.property.value | currency: 'USD' : true : '1.0-0' }}</span>
                          </td>
                          <td class="cursor-pointer text-captilize" (click)="openRightModal(listing?.property, 'edit_listing_property')">
                            {{
                              listing?.associate_date
                                ? (listing?.associate_date | date: 'dd/MM/yy')
                                : (listing?.property.created_at | date: 'dd/MM/yy')
                            }}
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="7">No record found.</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade {{ rPropActiveIndex === 2 && 'show active' }}"
                [id]="'property' + tabIndex"
                role="tabpanel"
                [attr.aria-labelledby]="'pills-property' + tabIndex + '-tab'"
                tabindex="0">
                <div class="d-flex align-items-center my-3">
                  <div class="w-100 pr-0 pr-3">
                    <span class="p-input-icon-left w-100">
                      <i class="pi pi-search search_i"></i>
                      <p-autoComplete
                        class="autocomplete-icon"
                        [(ngModel)]="attach_property"
                        [virtualScroll]="false"
                        [suggestions]="filteredProperty"
                        field="property_address"
                        (completeMethod)="searchProperties($event)"
                        (onSelect)="propertySelection($event)"
                        placeholder="Search Property">
                      </p-autoComplete>
                    </span>
                  </div>
                  <div>
                    <button class="btn-sm preview-btn f-12" (click)="attachProperty()" [class.disabled]="listingBtnDisable">Associate</button>
                  </div>
                </div>
                <div class="mb-3" *ngIf="!filteredProperty?.length && property_search_complete">
                  <a class="custom-a f-12" href="javascript:void(0)" (click)="openRightModal(null, 'add_property')">
                    <i class="pi pi-plus f-10 mr-2"></i>Add New Property
                  </a>
                </div>
                <div class="mt-2 pt-2 property_section">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="position-relative">
                        <div class="s-custom-entity-records scrol_ mxh-400" (scroll)="onSidePropertyScroll($event)" #sidePropertyScrollableElement>
                          <i class="pi pi-arrow-up" (click)="sidePropertyScrollToTop()" *ngIf="sidePropertyScrollTop > 50"></i>
                          <p-table
                            styleClass="pagination-dropdown"
                            scrollWidth="100%"
                            dataKey="_id"
                            [value]="attached_properties"
                            [paginator]="false"
                            [rows]="sidePropertyRows"
                            [(selection)]="selectedRows">
                            <ng-template pTemplate="header">
                              <tr>
                                <th class="pl-0 w-40px"></th>
                                <th class="pl-3 property_th_1" pSortableColumn="type">
                                  Tags
                                  <p-sortIcon field="type" class="ml-2"></p-sortIcon>
                                </th>
                                <th class="pl-3 property_th_2" pSortableColumn="property_data.property_address">
                                  Address
                                  <p-sortIcon field="property_data.property_address" class="ml-2"></p-sortIcon>
                                </th>
                                <th class="pl-3 property_th_3" pSortableColumn="property_data.type">
                                  Type
                                  <p-sortIcon class="ml-2" field="property_data.type"></p-sortIcon>
                                </th>
                                <th
                                  class="pl-3 property_th_4 {{ attached_properties?.length == 0 ? 'd-flex' : '' }}"
                                  pSortableColumn="property_data.date">
                                  Settlement Date
                                  <p-sortIcon class="ml-2" field="property_data.date"></p-sortIcon>
                                </th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-listing>
                              <tr>
                                <td class="w_auto">
                                  <button class="btn p-0" (click)="deleteAttachedProperty(listing?._id)">
                                    <img [src]="common_images?.delete_icon" alt="delete" width="16px" />
                                  </button>
                                </td>
                                <td
                                  class="w_auto"
                                  class="cursor-pointer text-captilize"
                                  (click)="openRightModal(listing?.property_data, 'edit_property')">
                                  {{ listing?.type }}
                                </td>
                                <td
                                  class="w_auto"
                                  class="cursor-pointer text-captilize"
                                  (click)="openRightModal(listing?.property_data, 'edit_property')">
                                  {{ listing?.property_data?.property_address }}
                                </td>
                                <td
                                  class="w_auto"
                                  class="cursor-pointer text-captilize"
                                  (click)="openRightModal(listing?.property_data, 'edit_property')">
                                  {{ listing?.property_data?.type }}
                                </td>
                                <td
                                  class="w_auto"
                                  class="cursor-pointer text-captilize"
                                  (click)="openRightModal(listing?.property, 'edit_listing_property')">
                                  <ng-container *ngIf="listing?.date; else no_settle">
                                    {{ listing?.date | date: 'dd/MM/yy' }}
                                  </ng-container>
                                  <ng-template #no_settle>
                                    {{ listing?.property_data?.date | date: 'dd/MM/yy' }}
                                  </ng-template>
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="7">No record found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade {{ rPropActiveIndex === 4 && 'show active' }}"
                [id]="'contract' + tabIndex"
                role="tabpanel"
                [attr.aria-labelledby]="'pills-contract' + tabIndex + '-tab'"
                tabindex="0">
                <div class="mt-3">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="position-relative">
                        <div class="s-custom-entity-records scrol_ mxh-400" (scroll)="onSideContractScroll($event)" #sideContractScrollableElement>
                          <i class="pi pi-arrow-up" (click)="sideContractScrollToTop()" *ngIf="sideContractScrollTop > 50"></i>
                          <p-table
                            styleClass="pagination-dropdown"
                            scrollWidth="100%"
                            dataKey="_id"
                            [value]="attached_contracts"
                            [paginator]="false"
                            [rows]="sideContractRows"
                            [(selection)]="selectedRows">
                            <ng-template pTemplate="header">
                              <tr>
                                <th class="pl-0 w-40px"></th>
                                <th class="contract_th pl-3">Tags</th>
                                <th class="pl-3 contract_th_1">Address</th>
                                <th class="pl-3 contract_th">Status</th>
                                <th class="pl-3 contract_th_2">Offer Price</th>
                                <th class="pl-3 contract_th_3">Contract Issue date</th>
                                <th class="pl-3 contract_th">Cancelled</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-contract>
                              <tr>
                                <td class="w_auto">
                                  <button class="btn p-0" (click)="deleteAttachedListing(contract?._id, 'contract')">
                                    <img [src]="common_images?.delete_icon" alt="delete" width="14px" />
                                  </button>
                                </td>
                                <td class="cursor-pointer text-captilize w_auto" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.type }}
                                </td>
                                <td class="cursor-pointer text-captilize w_auto" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.property_address ? contract?.property_address : contract?.project_name }}
                                </td>
                                <td class="cursor-pointer text-captilize w_auto" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.offer_status ? contract?.offer_status : contract?.contractStatus }}
                                </td>
                                <td class="cursor-pointer text-captilize w_auto" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.offerPrice ? contract?.offerPrice : (contract?.contract_price | currency: 'USD' : true : '1.0-0') }}
                                </td>
                                <td class="cursor-pointer text-captilize w_auto" (click)="openRightModal(contract, 'edit_contract')">
                                  <ng-container *ngIf="contract?.contractIssuedDate; else noissueDate">
                                    {{ contract?.contractIssuedDate | date: 'dd/MM/yy' }}
                                  </ng-container>
                                  <ng-template #noissueDate>
                                    {{ contract?.contract_issued_date | date: 'dd/MM/yy' }}
                                  </ng-template>
                                </td>
                                <td class="cursor-pointer text-captilize w_auto" (click)="openRightModal(contract, 'edit_contract')">
                                  {{ contract?.cancelledDate || contract?.cancelled_date ? 'Yes' : 'No' }}
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="7">No record found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 5 && 'show active' }}"
          *ngIf="!isPrivate"
          [id]="'rContact' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-rContact' + tabIndex + '-tab'"
          tabindex="0">
          <div class="d-flex w-400px align-items-center" *ngIf="!attached_contacts?.length">
            <img [src]="images?.related_contact" class="w-50px" />
            <div>
              <p class="l-h-1-31 f-12">Search contacts to associate with this contact.</p>
            </div>
          </div>
          <div class="mb-1">
            <div class="row align-items-end">
              <div class="col-sm-10 pb-1 p-autocomplete-70 position-relative" style="width: 300px">
                <label for="" style="width: 100%">
                  <re-multiselect
                    [module]="'contacts'"
                    [placeholder]="'Select'"
                    [truncate]="25"
                    [isMultiple]="false"
                    [isCreateNew]="true"
                    [isClear]="true"
                    [isEmail]="true"
                    [isFullObject]="true"
                    [escapeOverflow]="true"
                    (createNew)="openRightModal(null, 'add_contact')"
                    [selected_ids]="selectedRelatedContact"
                    (onUpdate)="contactSelection($event)"
                    [style]="{ width: '100%' }"></re-multiselect>
                </label>
              </div>
              <div class="col-2">
                <button class="_outline-btn" (click)="attachContact()" [class.disabled]="isAttachingContact" [disabled]="isAttachingContact">
                  Associate
                </button>
              </div>
            </div>
            <p class="f-12 mt-1">When creating a new Contact, press Save and not Save and Close</p>
          </div>
          <ng-container *ngIf="attached_contacts?.length > 0 && attached_contacts[0]">
            <div class="col-12 contact-tags mt-3 px-0" *ngIf="attached_contacts?.length">
              <div *ngIf="UserForm.controls['type'].value !== 'Company'">
                <div class="cs-related-contact">
                  <p class="f-12 font-weight-bold">Contact Type</p>
                  <div class="d-flex align-items-center flex-wrap" *ngIf="contactType" cdkDropList [cdkDropListConnectedTo]="getConnectedTo()">
                    <span class="related-tag primary-chip" *ngFor="let tag of contactType" cdkDrag [cdkDragData]="tag.tag_name">
                      <span class="p-tag-value">{{ tag.tag_name }}</span>
                    </span>
                  </div>
                </div>
                <div class="cs-related-contact">
                  <p class="f-12 font-weight-bold mt-3">Relationship</p>
                  <div class="d-flex align-items-center flex-wrap" cdkDropList [cdkDropListConnectedTo]="getConnectedTo()">
                    <span class="related-tag primary-chip" *ngFor="let tag of lmService.contact_relations" cdkDrag [cdkDragData]="tag.name">
                      <span class="p-tag-value">{{ tag.name }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="UserForm.controls['type'].value === 'Company'">
                <div class="cs-related-contact">
                  <p class="f-14 font-weight-bold">Company Role</p>
                  <div class="d-flex align-items-center flex-wrap" cdkDropList [cdkDropListConnectedTo]="getConnectedTo()">
                    <span class="related-tag primary-chip" *ngFor="let tag of companyRole" cdkDrag [cdkDragData]="tag.tag_name">
                      <span class="p-tag-value">{{ tag.tag_name }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="position-relative mt-2">
                <div
                  class="s-custom-entity-records rcontact-table scrol_ history mxh-300"
                  (scroll)="onRelatedContactScroll($event)"
                  #relatedContactScrollableElement>
                  <i class="pi pi-arrow-up" (click)="relatedContactScrollToTop()" *ngIf="relatedContactScrollTop > 50"></i>
                  <p-table
                    id="customentitydatalist"
                    class="related_contacts"
                    [value]="attached_contacts"
                    [columns]="ContactColumns"
                    dataKey="_id"
                    [rowHover]="false"
                    [rows]="relatedContactRows"
                    [autoLayout]="true"
                    [customSort]="true"
                    (onSort)="onRContactSort($event)"
                    [resizableColumns]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="text-center w-10px"></th>
                        <ng-container *ngFor="let col of ContactColumns">
                          <th class="f-12" *ngIf="col.column != '_id' && col.column != 'Email'" [pSortableColumn]="col.field">
                            <div class="p-d-flex p-ai-center">
                              {{ col.column }}
                              <p-sortIcon [field]="col.field" class="ml-2"></p-sortIcon>
                            </div>
                          </th>
                          <th class="f-12" *ngIf="col.column == 'Email'" [pSortableColumn]="col.field">
                            <div class="p-d-flex p-ai-center">
                              {{ col.column }}
                              <p-sortIcon [field]="col.field" class="ml-2"></p-sortIcon>
                            </div>
                          </th>
                        </ng-container>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-task let-columns="columns">
                      <tr class="cp">
                        <td class="r_contact">
                          <button class="btn p-0">
                            <img [src]="common_images?.delete_icon" alt="delete" width="16px" (click)="deleteAttachedContact(task._id)" />
                          </button>
                        </td>
                        <ng-container *ngFor="let col of ContactColumns">
                          <td
                            cdkDropList
                            [id]="'s_' + task?._id"
                            class="cursor-pointer"
                            *ngIf="col.field === 'relation'"
                            [cdkDropListData]="task['type']"
                            (cdkDropListDropped)="drop($event, task)">
                            <ng-container *ngFor="let tag of task['relation']">
                              <p-chip styleClass="mr-2 f-10 primary-chip">
                                <span class="p-chip-text">{{ tag }}</span>
                                <i class="pi pi-times f-10 ml-1 cursor-pointer" (click)="removeTag(tag, task)"></i>
                              </p-chip>
                            </ng-container>
                          </td>
                          <td class="cursor-pointer" *ngIf="col.field !== 'relation'" (click)="openRightModal(task?.contact, 'edit_contact')">
                            <p class="f-12 pl-0">
                              <ng-container *ngIf="col.field !== 'address' && col.field !== 'full_name' && col.field !== 'company_name'">
                                {{ task['contact'][col.field] }}
                              </ng-container>
                              <ng-container *ngIf="col.field === 'address'">
                                {{ task['contact']['property_address'] }}
                              </ng-container>
                              <ng-container *ngIf="col.field === 'full_name'">
                                {{ task['contact']['full_name'] }}
                              </ng-container>
                              <ng-container *ngIf="col.field === 'company_name'">
                                <ng-container *ngFor="let company of task['contact']['companies']; let last = last"
                                  >{{ company }} <span *ngIf="!last">, </span></ng-container
                                >
                              </ng-container>
                            </p>
                          </td>
                        </ng-container>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td class="w_auto" colspan="4">No record found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
                <div class="mt-2">
                  <p *ngIf="attached_contacts?.length > 0">
                    {{ 'Records: ' + attached_contacts?.length }}
                  </p>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 6 && 'show active' }}"
          *ngIf="!isPrivate"
          [id]="'Associations' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-Associations' + tabIndex + '-tab'"
          tabindex="0">
          <div class="d-flex align-items-center primary-tabs b-b-tabs">
            <ul class="nav tools-tab-nav w-100 align-items-end" role="tablist">
              <li class="nav-item cursor-pointer" role="presentation">
                <a
                  class="active"
                  [id]="'pills-project_associate' + tabIndex + '-tab'"
                  data-bs-toggle="pill"
                  [attr.data-bs-target]="'#project_associate' + tabIndex"
                  role="tab"
                  [attr.aria-controls]="'project_associate' + tabIndex"
                  aria-selected="false">
                  Associations
                  <p class="f-10 ml-2 a-head-badge" *ngIf="AssociatedProjectsUsers?.length > 0">
                    {{ AssociatedProjectsUsers?.length }}
                  </p>
                </a>
              </li>
              <li
                class="nav-item cursor-pointer"
                role="presentation"
                *ngIf="
                  (userPermission.includes('agreement.view') || userRole == 'master admin' || userRole == 'operations manager') && !disabled_tab
                ">
                <a
                  class=""
                  [id]="'pills-project_aggrement' + tabIndex + '-tab'"
                  data-bs-toggle="pill"
                  [attr.data-bs-target]="'#project_aggrement' + tabIndex"
                  role="tab"
                  [attr.aria-controls]="'project_aggrement' + tabIndex"
                  aria-selected="false">
                  Agreements
                  <p class="f-10 ml-2 a-head-badge" *ngIf="agreementProjectsUsers?.length > 0">
                    {{ agreementProjectsUsers?.length }}
                  </p>
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade show active"
              [id]="'project_associate' + tabIndex"
              role="tabpanel"
              [attr.aria-labelledby]="'pills-project_associate' + tabIndex + '-tab'"
              tabindex="0">
              <div class="position-relative">
                <ng-container *ngIf="UserForm.controls['type'].value !== 'Company'">
                  <div
                    class="mb-3 mt-2"
                    *ngIf="userPermission.includes('contact.view') || userRole == 'master admin' || userRole == 'operations manager'">
                    <button (click)="accessRemmi = !accessRemmi" class="preview-btn" [disabled]="isPrivate">Access Remmi</button>
                  </div>
                </ng-container>
                <ng-container *ngIf="accessRemmi">
                  <div class="row mb-3">
                    <div class="col-sm-9 pr-0">
                      <div class="form-group position-relative mb-0">
                        <label for="password">Password</label>
                        <input
                          [type]="showPassword ? 'text' : 'password'"
                          class="site-input"
                          [(ngModel)]="randomstring"
                          [readonly]="isPrivate"
                          autocomplete="new-password"
                          [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                        <i class="eye-icon" [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'" (click)="showHidePassword()"></i>
                      </div>
                      <p class="invalid-form" *ngIf="randomstring && randomstring?.length < 12">Password must be at least 12 characters long</p>
                    </div>
                    <div class="col-sm-3 mt-3">
                      <button class="preview-btn btn-sm f-12" (click)="generatePassword()">Generate Password</button>
                    </div>
                  </div>
                </ng-container>
                <div class="scrol_ asc_height" (scroll)="onScroll($event)" #scrollableElement>
                  <i class="pi pi-arrow-up" (click)="scrollToTop()" *ngIf="scrollTop > 50"></i>
                  <p-table
                    #dt1
                    *ngIf="AssociatedProjectsUsers"
                    [value]="AssociatedProjectsUsers"
                    (sortFunction)="onSortChange($event)"
                    [globalFilterFields]="['Project_Name']"
                    [(selection)]="AssociatedProjectSelection"
                    dataKey="_id">
                    <ng-template pTemplate="caption">
                      <div class="{{ isMobile ? 'd-block' : 'd-flex' }}">
                        <div class="position-relative">
                          <input
                            type="text"
                            (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            class="_input-icon"
                            placeholder="Search keyword" />
                          <i class="pi pi-search _search-icon"></i>
                        </div>
                        <div class="ml-auto mr-2 d-flex class-add-project">
                          <re-multiSelect
                            [options]="lmService?.ProjectList"
                            *ngIf="AssociatedProjectSelection.length < 1"
                            [(selectedOptions)]="AddNewProject"
                            optionLabel="Project_Name"
                            optionValue="_id"
                            class="multiselect"
                            class="msContainer mr-2 multiselect"
                            placeholder="Add project"></re-multiSelect>
                          <button
                            *ngIf="AddNewProject && AssociatedProjectSelection.length < 1"
                            class="_addNew cs_add"
                            (click)="AssociateUserToProject('add', AddNewProject)">
                            <i class="f-10 pi pi-plus f-14 _fw-600 text-primary"></i>
                          </button>
                          <button
                            (click)="AssociateUserToProject('remove', AssociatedProjectSelection)"
                            *ngIf="AssociatedProjectSelection.length > 0"
                            pButton
                            label="Delete"
                            class="p-button-outlined"
                            icon="pi pi-trash"></button>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th pSortableColumn="Project_Name">
                          <div class="d-flex align-items-center">
                            <p class="mr-2">Name</p>
                            <p-sortIcon field="Project_Name"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="createdon">
                          <div class="d-flex align-items-center">
                            <p class="mr-2">Create Date</p>
                            <p-sortIcon field="createdon"></p-sortIcon>
                          </div>
                        </th>
                        <th class="w-50px">&nbsp;</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-project>
                      <tr class="compact-form">
                        <td>
                          <p>{{ project.Project_Name }}</p>
                        </td>
                        <td>
                          <p>{{ project.createdon | date: 'dd/MM/yy' }}</p>
                        </td>
                        <td class="text-center">
                          <button class="btn p-0">
                            <img [src]="common_images?.delete_icon" alt="delete" width="17px" (click)="AssociateUserToProject('remove', [project])" />
                          </button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade show"
              [id]="'project_aggrement' + tabIndex"
              role="tabpanel"
              [attr.aria-labelledby]="'pills-project_aggrement' + tabIndex + '-tab'"
              tabindex="0">
              <div class="mt-3">
                <p-table
                  styleClass="pagination-dropdown"
                  scrollWidth="100%"
                  [value]="agreementProjectsUsers"
                  [rows]="sidePropertyRows"
                  [(selection)]="selectedRows">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="project_th">Project</th>
                      <th class="project_th_1">Agreement Type</th>
                      <th class="project_th_1">Agreement Status</th>
                      <th class="project_th">Agreement Executed Date</th>
                      <th class="project_th_1">Created Date</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-agreed>
                    <tr (click)="openAgreement(agreed)" class="cursor-pointer">
                      <td class="pl-1">{{ agreed.project }}</td>
                      <td class="pl-1">{{ agreed.agreement_type }}</td>
                      <td class="pl-1">{{ agreed.agreement_status }}</td>
                      <td class="pl-1">{{ agreed.agreement_exe_date | date: 'dd/MM/yy' }}</td>
                      <td class="pl-1">{{ agreed.created_at | date: 'dd/MM/yy' }}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="7">No record found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
              <p-dialog
                header="Update Agreement"
                [showHeader]="true"
                [(visible)]="agreement_dialog"
                [draggable]="false"
                [style]="{ width: '70vw' }"
                [modal]="true"
                [baseZIndex]="100000"
                [contentStyleClass]="'confirmDeleteViewDialog'">
                <ng-container *ngIf="agreement_dialog">
                  <app-developer-agreement (is_agreement)="agreementhide($event)" [agree]="agreement_detail"></app-developer-agreement>
                </ng-container>
              </p-dialog>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 7 && 'show active' }}"
          *ngIf="!isPrivate"
          [id]="'cNotes' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cNotes' + tabIndex + '-tab'"
          tabindex="0">
          <div *ngIf="rightActiveIndex === 7" class="notes-mod mt-2">
            <app-notes
              [moduleId]="
                this.selectedContact || {
                  _id: this.insertedUserId,
                  property_address: UserForm.controls['full_name']?.value || UserForm.controls['company_name']?.value,
                }
              "
              [type]="'contacts'"></app-notes>
          </div>
        </div>
        <div
          class="tab-pane fade {{ rightActiveIndex === 8 && 'show active' }}"
          *ngIf="!isPrivate"
          [id]="'cHistory' + tabIndex"
          role="tabpanel"
          [attr.aria-labelledby]="'pills-cHistory' + tabIndex + '-tab'"
          tabindex="0">
          <ng-container *ngIf="rightActiveIndex === 8">
            <app-remmi-history [module]="'Contact'" [record_id]="contactDetails?.contactid || contactDetails?._id"></app-remmi-history>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<p-dialog
  [modal]="true"
  [style]="{ width: '70vw' }"
  [draggable]="false"
  [(visible)]="contactConflict"
  [autoZIndex]="true"
  position="center"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [transitionOptions]="'2ms'"
  appendTo="body">
  <ng-template pTemplate="header">
    <h5>Found similar contact, please confirm if you wish to create a new contact record.</h5>
  </ng-template>
  <div class="col-md-12">
    <div *ngIf="cContacts.length > 0">
      <p-table
        id="customentitydatalist"
        [value]="cContacts"
        dataKey="_id"
        [rowHover]="false"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="true"
        currentPageReportTemplate="Results: {first} - {last} of {totalRecords}"
        [customSort]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>First name</th>
            <th>Last name</th>
            <th>Email</th>
            <th>Type</th>
            <th>Contact type</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-contact>
          <tr>
            <td>{{ contact?.first_name }}</td>
            <td>{{ contact?.last_name }}</td>
            <td>{{ contact?.email }}</td>
            <td>{{ contact?.user_type }}</td>
            <td>{{ contact?.contact_type?.toString()?.split(',')?.join(', ') }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">No record found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="w-100 text-right">
    <button type="button" class="_cancel-btn mr-2" (click)="contactConflict = false">Cancel</button>
    <button type="button" class="_outline-btn" (click)="createContact()">Create New</button>
  </div>
</p-dialog>

<!-- tags -->
<p-dialog
  [styleClass]="'noHeader'"
  [showHeader]="false"
  [(visible)]="lmService.tag_manager"
  [style]="{ width: '350px' }"
  [position]="'right'"
  styleClass="tag-sidebar-manager">
  <div class="px-2 py-2">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="f-18">Tag Manager</h3>
      <div class="d-flex">
        <button class="_view-btn p-2 h-auto" type="button" (click)="new_tag_popup = true">
          <i class="pi pi-plus f-12"></i>
        </button>
        <button class="ml-3 _view-btn p-2 h-auto" type="button" (click)="closeTagManger()">
          <i class="pi pi-times f-12"></i>
        </button>
      </div>
    </div>
    <div class="mb-4">
      <div class="w-100 my-2 mr-3 position-relative with-right-icon mnw-230px">
        <input class="site-input" type="text" #searchKeyword [(ngModel)]="keywordTags" placeholder="Search Tags" />
        <i class="f-14 pi pi-search cp tag_i" *ngIf="!keywordTags"></i>
        <i class="pi pi-times cp tag_i" *ngIf="keywordTags" (click)="noTagsFound = false; resetTagSearch()"></i>
      </div>
    </div>

    <div class="overflow-tags" *ngFor="let status of tagsData; let i = index">
      <ng-container *ngFor="let type of status?.types; let ind = index">
        <div *ngIf="type?._id !== 'createnew'" class="mr-2">
          <div class="box-header mt-2" (click)="toggleBox(type)">
            <p>{{ type.name }}</p>
            <i class="pi f-12" [ngClass]="{ 'pi-minus': type.isOpen, 'pi-plus': !type.isOpen }"></i>
          </div>
          <div class="box-content" [hidden]="!type.isOpen">
            <div class="d-flex flex-wrap" cdkDropList [cdkDropListData]="type?.data" [cdkDropListConnectedTo]="[doneList]">
              <div *ngFor="let tag of type?.data; let j = index" cdkDrag>
                <div
                  class="d-flex align-items-center mt-2 tag-dev mr-2 cursor-pointer"
                  (dblclick)="addTagInForm(0, tag)"
                  pTooltip="Double click to add"
                  tooltipPosition="top">
                  <p class="p-chip-text">{{ tag?.tag_name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="noTagsFound">
      <p class="text-muted text-center py-1">No data found</p>
    </div>
  </div>
</p-dialog>

<!-- Tag Type -->
<p-dialog
  [(visible)]="newTagTypePopUp"
  [position]="'right'"
  [modal]="true"
  [style]="{ width: '300px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'noHeader'"
  [showHeader]="false"
  styleClass="tag-sidebar-manager">
  <div>
    <div>
      <div class="mt-2">
        <label class="mb-1">Tag Type</label>
        <input type="text" placeholder="Tag type name" [(ngModel)]="tag_type" class="site-input" />
      </div>
    </div>
    <div class="flexCenterEnd mt-2">
      <button class="_cancel-btn mr-2" (click)="tag_type = null; newTagTypePopUp = false">Cancel</button>
      <button class="_outline-btn float-right" [class.disabled]="!tag_type" (click)="createTagType()">Add</button>
    </div>
  </div>
</p-dialog>

<!-- New tag -->
<p-dialog
  [(visible)]="new_tag_popup"
  [position]="'right'"
  [modal]="true"
  [style]="{ width: '300px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'noHeader'"
  [showHeader]="false"
  styleClass="tag-sidebar-manager">
  <div class="p-2">
    <div>
      <div class="mt-2">
        <label class="mb-1 px-1 d-flex align-items-center justify-content-between"> Tag Type </label>
        <div *ngIf="tagsData.length > 0">
          <ng-select
            class="tag-type"
            [items]="tagsData[0]?.types"
            [(ngModel)]="tag_type"
            bindLabel="name"
            bindValue="_id"
            placeholder="Select Tag Type"
            [showClear]="true"
            (change)="isNewTypeModel($event)">
            <ng-template ng-option-tmp let-item="item">
              <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
            </ng-template>
          </ng-select>
        </div>
        <small class="px-1 f-10">Select a module to see its tag types</small>
      </div>

      <div class="mt-2 chips-custom">
        <label class="mb-1 px-1 w-100 d-flex align-items-center justify-content-between">
          {{ userRole == 'master admin' || userRole == 'operations manager' ? 'Tags*' : 'Request New Tag*' }}
        </label>
        <div class="tag-chip">
          <p-chips [(ngModel)]="new_tag" placeholder="Add Multiple Tags" styleClass="w-100" (onAdd)="pushTagToArray($event)"> </p-chips>
          <small class="px-1 f-10">Press enter after typing tag name</small>
        </div>
      </div>
    </div>
    <div class="flexCenterEnd mt-2">
      <button class="_cancel-btn mr-2" (click)="onCancelTagDialog()">Cancel</button>
      <button class="preview-btn" [class.disabled]="!new_tag?.length || loading || !tag_type?.length" (click)="createTag()">
        {{ userRole == 'master admin' || userRole == 'operations manager' ? 'Add' : 'Request Tag' }}
      </button>
    </div>
  </div>
</p-dialog>

<div class="send_email_modal">
  <p-dialog
    [(visible)]="email_modal"
    [position]="'center'"
    [styleClass]="'noHeader'"
    [showHeader]="false"
    [style]="isMobile ? { width: '750px', margin: '0px 10px' } : { width: '750px', 'margin-top': '140px' }">
    <div class="headerIcon d-flex justify-content-end">
      <div class="crossiconStyle cursor-pointer event_poup_close_btn">
        <img [src]="common_images?.close_icon" class="p-1" width="30px" (click)="email_modal = false" />
      </div>
    </div>
    <div class="row ml-0 mr-0 mt-2">
      <div class="col-md-12">
        <div class="col-sm-12 mt-0">
          <label class="f-14 mb-1">To</label>
          <input type="text" name="stakeholder" disabled [(ngModel)]="emailTo" />
        </div>
        <div class="col-sm-12 mt-2">
          <label class="f-14 mb-1">From</label>
          <input type="text" name="stakeholder" disabled [(ngModel)]="emailFrom" />
        </div>
        <div class="col-sm-12 mt-2">
          <label class="f-14 mb-1">Select Template</label>
          <ng-select
            [items]="emailTemplates"
            [(ngModel)]="emailTempSelectedId"
            name="emailTemplate"
            bindLabel="name"
            bindValue="_id"
            [searchable]="true"
            (change)="getTemplateBody()"
            [clearable]="false"
            placeholder="Email Template">
            <ng-template ng-option-tmp let-item="item">
              <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-sm-12 mt-2">
          <label class="f-14 mb-1">Subject</label>
          <input type="text" name="subject" [(ngModel)]="emailSubject" />
        </div>
        <div class="col-sm-12 mt-2">
          <label class="f-14 mb-1">Body</label>
          <div class="w-100 _paragraph">
            <ckeditor [(ngModel)]="emailBody" class="email_modal_body" [editor]="Editor" [config]="ckEditorToolbar"> </ckeditor>
          </div>
        </div>
        <div class="d-flex align-items-center mt-3 mb-2 justify-content-end">
          <button class="_cancel-btn mr-3" (click)="email_modal = false">Cancel</button>
          <button (click)="sendEmail()" class="_outline-btn">Send</button>
        </div>
      </div>
    </div>
  </p-dialog>

  <!--
    A contact can be associated with several projects (or none), so no project is
    passed — the dialog asks the agent to pick one.
  -->
  <app-external-eoi-generate-modal
    [visible]="showExternalEoiModal"
    [contactId]="externalEoiContactId"
    [contactName]="externalEoiContactName"
    [contactEmail]="selectedContact?.email || ''"
    (closed)="showExternalEoiModal = false"></app-external-eoi-generate-modal>
</div>
